import type { MathRun } from '../../../Shared/Pdf/mathRuns.ts';

/** Spanish place-value prompts (ADR 0051 part 3). See the English module for why each clause is written whole. */
export const placeClauses: string[] = [
    // Deliberately the short form ("está en las centenas"), not
    // "en el lugar de las centenas". ADR 0051 §7 part 3's Language sweep
    // found the longer clauses ran Digit Value onto an extra page at 10 and
    // 12 per page - the clause is interpolated into every problem, so its
    // length is multiplied by the per-page count. Both forms are idiomatic.
    'en las unidades',
    'en las decenas',
    'en las centenas',
    'en los millares',
    'en las decenas de millar',
];

export const placeValuePrompts = {
    digitValue: (value: string, digit: number, placeClause: string) =>
        `En ${value}, el ${digit} está ${placeClause}. Su valor es`,
    // ADR 0130 §5. Every prompt is MathText runs, even one with no exponent, so
    // the two directions look alike on the page. The exponent is an ASCII "-" (ADR 0070).
    toScientific: (standard: string): MathRun[] => [{ text: `Escribe ${standard} en notación científica.` }],
    toStandard: (coefficient: string, exponent: number): MathRun[] => [
        { text: `Escribe ${coefficient} × 10` },
        { sup: String(exponent) },
        { text: ' en forma estándar.' },
    ],
};
